import { SelectorMatch } from '@fullstory/selectors';
import { ClickFacet, Stat } from './activitymaps';
import { ComputeElementStatsResponse } from '@fullstory/proto/fs/services/alexa';
import { NativePlatform } from '@fullstory/proto/fs/api/segment';

export interface Inspector {
  // Will highlight in the DOM and reply asynchronously to the InspectorHost with discovered and parsed selectors.
  select(selector: string);
  // Will only highlight in the DOM.
  preview(selector: string);
  generateStats(statsResponse: ComputeElementStatsResponse, selector: string);
  // triggers an updateLogicalPageContentRoot() callback with the new screen selector
  getLogicalPageContentRoot();
}

export class ElementProposal {
  fullSelector: SelectorMatch;
  similarElements: SelectorMatch[];
  text?: string;
}

export interface InspectorHost {
  // fullSelector is the fully specified long ugly selector we are matching.
  // similarElements are the elements that could be what the user intended to match.
  updateProposal(proposal: ElementProposal, notTyping?: boolean);
  // logicalPageContentRoot is the selector of the container element
  // that logically maps to the lowest node in the view/dom tree
  // which encompasses the current 'screen' or 'page' contents.
  // For Mobile this maps to the view that is created by an Android Fragment, or
  // the top most iOS UIViewController within a NavigationStack,
  // And can be extended to Web within a framework like a react-router
  // component.
  updateLogicalPageContentRoot(selector: SelectorMatch | null);
  showStats(clicks: ClickFacet, stats: Stat[], nativePlatform: NativePlatform);
  complainSelector(complaint: string, link?: string);
}

//
// Client stubs for auto-proxying.
// TODO(jaime): Code gen this.
export class InspectorClientStub implements Inspector {
  select(selector: string): void {}
  preview(selector: string): void {}
  generateStats(statsResponse: ComputeElementStatsResponse, selector: string) {}
  getLogicalPageContentRoot(): void {}
}

export class InspectorHostClientStub implements InspectorHost {
  updateProposal(proposal: ElementProposal, notTyping?: boolean) {}
  updateLogicalPageContentRoot(selector: SelectorMatch | null) {}
  showStats(clicks: ClickFacet, stats: Stat[], nativePlatform: NativePlatform) {}
  complainSelector(complaint: string, link?: string) {}
}
